import axios from "axios";
import APIURL from "../../../Main/apiurl";

export const get_ap_report = async (data) => {
  try {
    const token = localStorage.getItem("user");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axios.post(
      `${APIURL}/get-ap-report`,
      data,
      config
    );
    return response?.data;
  } catch (error) {
    return error?.response?.data || { success: false, message: error.message };
  }
};

export const get_supplier_pos = async (data) => {
  try {
    const token = localStorage.getItem("user");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axios.post(
      `${APIURL}/get-supplier-pos`,
      data,
      config
    );
    return response?.data;
  } catch (error) {
    return error?.response?.data || { success: false, message: error.message };
  }
};